/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { inventoryIndex } from '../../axios/inventoryIndex'
import type { InventoryIndexError, InventoryIndexPathParams, InventoryIndexResponse } from '../../types/InventoryIndex'

export const inventoryIndexQueryKey = (organisation: InventoryIndexPathParams['organisation']) =>
	[{ url: '/:organisation/inventory', params: { organisation } }] as const

export type InventoryIndexQueryKey = ReturnType<typeof inventoryIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::index */
export function inventoryIndexQueryOptions(
	organisation: InventoryIndexPathParams['organisation'],
	config?: AxiosRequestConfig,
) {
	return queryOptions<
		InventoryIndexResponse,
		AxiosError<InventoryIndexError>,
		InventoryIndexResponse,
		InventoryIndexQueryKey
	>({
		queryKey: inventoryIndexQueryKey(organisation),
		queryFn: ({ signal }) => inventoryIndex(organisation, { signal, ...config }).then(res => res.data),
		enabled: !!organisation,
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::index */
export function useInventoryIndex<TSelectData = InventoryIndexResponse>(
	organisation: InventoryIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					InventoryIndexResponse,
					AxiosError<InventoryIndexError>,
					TSelectData,
					InventoryIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<InventoryIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...inventoryIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/InventoryController.php InventoryController::index */
export function useInventoryIndexSuspense<TSelectData = InventoryIndexResponse>(
	organisation: InventoryIndexPathParams['organisation'],
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					InventoryIndexResponse,
					AxiosError<InventoryIndexError>,
					TSelectData,
					InventoryIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<InventoryIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...inventoryIndexQueryOptions(organisation),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
